import React from "react"
import { TextField } from '@material-ui/core';
import ImageChanger from "./imageChanger";
import Button from 'storybookComponents/Button';
import "./style.css"
import Field from "./common";

const EmailInvite = ({ classes, label_1,
  label_2,
  label_3,
  label_4,
  name_1,
  name_2,
  name_3,
  name_4,
  name_image,
  value_1,
  value_2,
  value_3,
  value_4,
  value_image,
  onChange,
  id,
  onInput,
  aboveImageText,
  children,
  assetCategory,
  showNotification,
  onFocus
}) => {

  const handleChange = (image) => {
    const obj = {
      target: {
        name: name_image,
        value: image
      }
    }
    onChange(obj);
    onInput({ target: { name: name_image, value: image } })
  }
  return (
    <div>
      <div className={classes.uploadText}>{aboveImageText}</div>
      <div className={`banner-container ${classes.imageButtonContainer}`}>
        <img src={value_image} width="200px" />
        <div className="banner-overlay">
          <ImageChanger
            assetCategory={assetCategory}
            base64={!Boolean(id)}
            showNotification={showNotification}
            onChange={handleChange}
            customButton={
              <Button color="hylyBlue" className={classes.changeButton} variant="primary" size="md">
                Change Image
              </Button>
            }
          />
        </div>
      </div>
      <div className={classes.imageText}>Image (600x340px)</div>
      <div className={classes.labelContainer}>
        <div class="hyly-rsvp-form">
          <Field onInput={onInput} fullWidth name={name_1} value={value_1} onChange={onChange} label={label_1} />
          {
            name_4 ?
              <Field onInput={onInput} fullWidth name={name_4} value={value_4} onChange={onChange} label={label_4} /> : null
          }
          <div className={classes.imageText}>{label_2}</div>
          <Field onInput={onInput} multiline name={name_2} value={value_2} onChange={onChange} fullWidth variant="outlined" onFocus={onFocus} />
          {
            children
          }
          {
            label_3 &&
            <>
              <div className={classes.imageText}  >{label_3}</div>
              <Field onInput={onInput} multiline name={name_3} value={value_3} onChange={onChange} fullWidth variant="outlined" onFocus={onFocus} />
            </>
          }

        </div>
      </div>
    </div>
  )
}


export default EmailInvite